import { z } from 'zod';

// AIDEV-NOTE: Schemas compartilhados para fotos de produtos (Cloudflare R2 metadata)

export const produtoFotoSchema = z.object({
  id: z.string().uuid(),
  client_id: z.number().int(),
  produto_codigo: z.number().int(),
  r2_key: z.string(),
  url: z.string().url(),
  ordem: z.number().int().min(0),
  created_at: z.string()
});

export type ProdutoFoto = z.infer<typeof produtoFotoSchema>;

export const reordenarFotosSchema = z.object({
  ordens: z.array(
    z.object({
      id: z.string().uuid(),
      ordem: z.number().int().min(0)
    })
  )
});

export type ReordenarFotosInput = z.infer<typeof reordenarFotosSchema>;

// AIDEV-NOTE: Schema para resposta batch de fotos — mapa de codigo para URLs
export const batchFotosResponseSchema = z.record(z.string(), z.array(z.string().url()));

export type BatchFotosResponse = z.infer<typeof batchFotosResponseSchema>;
